import { forwardRef } from 'react'
import { cn } from '@/shared/utils/cn'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, id, className, ...props }, ref) => {
    const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-')

    return (
      <div className="flex flex-col">
        {label && (
          <label
            htmlFor={inputId}
            className="mb-1.5 text-sm font-medium text-ue-text-secondary"
          >
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            'h-9 w-full rounded border border-ue-border-medium bg-ue-bg-medium px-3 text-sm text-ue-text-primary placeholder:text-ue-text-tertiary focus:border-ue-accent-blue focus:outline-none focus:ring-1 focus:ring-ue-accent-blue',
            error && 'border-ue-accent-red focus:border-ue-accent-red focus:ring-ue-accent-red',
            className
          )}
          {...props}
        />
        {error && (
          <p className="mt-1 text-xs text-ue-accent-red">{error}</p>
        )}
      </div>
    )
  }
)

Input.displayName = 'Input'
